import { FC } from 'react'

import { Slider } from '~shared'
import Card from './card'
import BannerComponent from './banner'
import { BannerProps } from './banner.type'

const Banner: FC<BannerProps> = ({ items, title }) =>
  items.length > 2 ? (
    <Slider
      title={title}
      items={items.map((props) => (
        <Card key={props.title} {...props} />
      ))}
      cardWidth={207}
      cardHeight={212}
    />
  ) : (
    <BannerComponent items={items} title={title} />
  )

export default Banner
